import { BrowserModule } from "@angular/platform-browser";
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, isDevMode } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ReportsWidgetsModule } from "./Admin/reports/reports-widgets.module";
import { LoginComponent } from "./Admin/login/login.component";
import { UserListComponent } from "./Admin/user-list/user-list.component";
import { ScreenShotViwerComponent } from "./Admin/screen-shot-viwer/screen-shot-viwer.component";
import { HeaderComponent } from "./Admin/header/header.component";
import { CreateUserComponent } from "./Admin/create-user/create-user.component";
import { AdminControlConfirmDialogComponent } from './Admin/create-user/admin-control-confirm-dialog/admin-control-confirm-dialog.component';
import { ProjectsComponent } from "./Admin/projects/projects.component";
import { AddProjectComponent } from "./Admin/projects/add-project/add-project.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatBadgeModule } from "@angular/material/badge";
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatRadioModule } from '@angular/material/radio';
import { TooltipDirectiveDirective } from "./tooltip-directive.directive";
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatMenuModule } from "@angular/material/menu";

import { SharedService } from "./Services/sharedService";

import { TimeLogsComponent } from "./Admin/time-logs/time-logs.component";
import { TabsComponent } from "./Admin/tabs/tabs.component";
import { WorkHabitsCardComponent } from "./Admin/work-habits-card/work-habits-card.component";
import { WorkInsightsSectionComponent } from "./Admin/work-insights-section/work-insights-section.component";
import { LogsDisplayModalComponent } from "./Admin/logs-display-modal/logs-display-modal.component";
import { LoaderComponent } from "./Admin/loader/loader.component";
import { DashboardComponent } from "./Admin/dashboard/dashboard.component";
import { MatCardModule } from "@angular/material/card";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { TimeagoModule } from "ngx-timeago";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatChipsModule } from "@angular/material/chips";

import { StatusFilterPipe } from "./status-filter.pipe";
import { ChartComponent } from "./chart/chart.component";
import { PieChartComponent } from "./pie-chart/pie-chart.component";
import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireDatabaseModule } from "@angular/fire/compat/database";
import { environment } from "../environments/environment";
import { MatSelectSearchComponent } from "./Admin/mat-select-search/mat-select-search.component";
import { ScreencastActionModelComponent } from "./screencast/screencast-action-model/screencast-action-model.component";
import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { A11yModule } from "@angular/cdk/a11y";
import { HeaderInterceptor } from "./header-interceptor.interceptor";
import { CacheInterceptor } from './interceptors/cache.interceptor';
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { DisplayToastComponent } from "./DisplayToast/display-toast/display-toast.component";
import { TeamListComponent } from "./Admin/projects/team-list/team-list.component";
import { TeamMemberListComponent } from "./Admin/projects/team-member-list/team-member-list.component";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { UsersTableComponent } from "./Admin/users-table/users-table.component";
import { StackedChartComponent } from "./stacked-chart/stacked-chart.component";
import { LineChartComponent } from "./line-chart/line-chart.component";
import { DonutChartComponent } from "./donut-chart/donut-chart.component";
import { CustomTooltipDirective } from "./custom-tooltip.directive";
import { TooltipModule } from "ng2-tooltip-directive";
import { GetUsersRolePipe, UserProfileComponent } from "./Admin/user-profile/user-profile.component";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { MatTooltipModule } from "@angular/material/tooltip";
import { UserSettingPanelComponent } from './Admin/user-setting-panel/user-setting-panel.component';
import { EmployeeEditComponent } from './Admin/employee-edit/employee-edit.component';
import { ApplicationUsageChartComponent } from './ApplicationUsageChart/application-usage-chart/application-usage-chart.component';
import { GoogleSigninComponent } from './components/google-signin/google-signin.component';
import { AuthBrandPanelComponent } from './components/auth-brand-panel/auth-brand-panel.component';
import { ApplicationUSageProgressbarComponent } from './ApplicationUSageProgressbar/application-usage-progressbar/application-usage-progressbar.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TourMatMenu, provideUiTour } from 'ngx-ui-tour-md-menu'
import { MatDividerModule } from '@angular/material/divider';
import { SignupComponent } from './signup/signup.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { VerificationCodeComponent } from './verification-code/verification-code.component';
import { ResetSucessfullyComponent } from './reset-sucessfully/reset-sucessfully.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { AvatarModule } from 'ngx-avatars';
import { ServiceWorkerModule } from '@angular/service-worker';
import { QuotaBannerComponent } from "./QuotaBanner/quota-banner/quota-banner.component";
import { DemoReportModalComponent } from "./QuotaBanner/demo-report-modal/demo-report-modal.component";
import { MessagingServiceService } from "./Services/messaging-service.service";
import { DialogTemplateComponent } from "./dialog-template/dialog-template/dialog-template.component";
import { UserProfileInfoComponent } from "./user-profile-info/user-profile-info/user-profile-info.component";
import { AddEmailComponent } from "./addEmail/add-email/add-email.component";
import { UserPlansComponent } from './user-plans/user-plans/user-plans.component';
import { PlanExpiredComponent } from './QuotaBanner/plan-expired/plan-expired.component';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { ApplyCouponComponent } from './components/apply-coupon/apply-coupon.component';
import { BillingHeroComponent } from './user-plans/billing-hero/billing-hero.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UserReportComponent } from './Admin/user-list/user-report/user-report.component';
import { AbsenceCalendarDialogComponent } from './Admin/user-list/user-report/absence-calendar-dialog/absence-calendar-dialog.component';
import { PolicyFooterComponent } from './policy-footer/policy-footer.component';
import { NgxCountriesDropdownModule } from 'ngx-countries-dropdown';
import { ImportUsersComponent } from './Admin/import-users/import-users.component';
import { UserFilterComponent } from './components/user-filter/user-filter.component';
import { UserOptionsComponent } from './components/user-options/user-options.component';
import { ProfileCompletionModalComponent } from './components/profile-completion-modal/profile-completion-modal.component';
import { BillingProfileModalComponent } from './components/billing-profile-modal/billing-profile-modal.component';
import { InviteFocusDialogComponent } from './components/invite-focus-dialog/invite-focus-dialog.component';
import { WelcomeNewUserComponent } from './components/welcome-new-user/welcome-new-user/welcome-new-user.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ExportTimeSheetComponent } from './components/export-timesheet/export-timesheet.component';
import { MagicLinkAuthComponent } from './magic-link-auth/magic-link-auth.component';
import { PhoneVerificationModalComponent } from './components/phone-verification-modal/phone-verification-modal.component';
import { SharedModule } from './shared/shared.module';
import { PrivacyPolicyComponent } from './policy-pages/privacy-policy/privacy-policy.component';
import { RefundPolicyComponent } from './policy-pages/refund-policy/refund-policy.component';
import { ShippingExchangePolicyComponent } from './policy-pages/shipping-exchange-policy/shipping-exchange-policy.component';
import { TermsConditionComponent } from './policy-pages/terms-condition/terms-condition.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { QuestionAndAnswerComponent } from './Admin/help-and-support/question-and-answer/question-and-answer.component';
import { MagicLinkGuard } from './utils/magic-link.guard';
import { ScreenshotsComponent } from './Admin/screenshots/screenshots.component';
import { SampleDataBannerComponent } from './components/sample-data-banner/sample-data-banner.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { UserListFilterComponent } from "./Admin/user-list/user-list-filter/user-list-filter.component";
import { StatusCardComponent } from "./Admin/dashboard/status-card/status-card.component";
import { BulkUpdateSettingsComponent } from "./Admin/bulk-update-settings/bulk-update-settings.component";
import { MinuteStepperComponent } from './shared/minute-stepper/minute-stepper.component';
import { OnboardingChecklistModule } from './onboarding-checklist/onboarding-checklist.module';
import { EmployeeSearchComponent } from './components/employee-search/employee-search.component';
import { ShiftDrawerComponent } from './Admin/shift/shift-drawer/shift-drawer.component';
import { ShiftFormComponent } from './Admin/shift/shift-form/shift-form.component';
import { ShiftManagementComponent } from './Admin/shift/shift-management/shift-management.component';
import { ShiftService } from './Services/shift.service';
import { SSCard } from "./Admin/ss-card/ss-card";
import { SHARED_PIPES } from "./Services/shared.pipe";
import { AuditLogsComponent } from "./Admin/audit-logs/audit-logs.component";
import { UtcToLocalPipe } from "./utc-to-local.pipe";
import { OptionalSetupHelpLinksComponent } from "./components/optional-setup-help-links/optional-setup-help-links.component";
import { ExamplePreviewCardComponent } from "./example-workday/previews/example-preview-card.component";
import { ActivationDataStateComponent } from "./onboarding-checklist/activation-data-state.component";
import { WorkReplayComponent } from "./Admin/work-replay/work-replay.component";
import { LiveMonitoringComponent } from "./live-monitoring/live-monitoring.component";
import { LiveScreencastQuotaMeterComponent } from "./live-monitoring/components/live-screencast-quota-meter/live-screencast-quota-meter.component";
import { LiveTileComponent } from "./live-monitoring/components/live-tile/live-tile.component";
import { SrcObjectDirective } from "./live-monitoring/directives/src-object.directive";
import { PlanUpgradeDialogComponent } from "./components/plan-upgrade-dialog/plan-upgrade-dialog.component";
import { FeatureLockedComponent } from "./entitlements/feature-locked/feature-locked.component";
import { EntitlementLockBannerComponent } from "./entitlements/entitlement-lock-banner/entitlement-lock-banner.component";
import { SsRequiresEntitlementDirective } from "./entitlements/ss-requires-entitlement.directive";
import { ProfessionalPlanAnnouncementDialogComponent } from "./components/professional-plan-announcement-dialog/professional-plan-announcement-dialog.component";
import { WhatsAppDailySummaryModalComponent } from "./components/whatsapp-daily-summary-modal/whatsapp-daily-summary-modal.component";
import { DowngradeValidationDialogComponent } from "./components/downgrade-validation-dialog/downgrade-validation-dialog.component";
import { HiddenToGeneralDialogComponent } from "./components/hidden-to-general-dialog/hidden-to-general-dialog.component";
import { AdminControlToGeneralDialogComponent } from "./components/admin-control-to-general-dialog/admin-control-to-general-dialog.component";
import { PersonalizedSettingsDialogComponent } from "./components/personalized-settings-dialog/personalized-settings-dialog.component";
import { TeamReductionDialogComponent } from "./components/team-reduction-dialog/team-reduction-dialog.component";
import { ShiftReductionDialogComponent } from "./components/shift-reduction-dialog/shift-reduction-dialog.component";
import { DeleteShiftDialogComponent } from './components/delete-shift-dialog/delete-shift-dialog.component';
import { OnBoardingComponent } from "./on-boarding/on-boarding.component";
import { PasswordResetsDialogComponent } from "./components/password-resets-dialog/password-resets-dialog.component";
import { DemoConsoleComponent } from "./demo-console/demo-console.component";
import { ConductTimelogsComponent } from "./Admin/conduct-timelogs/conduct-timelogs.component";
@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        UserListComponent,
        ScreenShotViwerComponent,
        HeaderComponent,
        CreateUserComponent,
        AdminControlConfirmDialogComponent,
        ProjectsComponent,
        AddProjectComponent,
        TimeLogsComponent,
        TabsComponent,
        WorkHabitsCardComponent,
        WorkInsightsSectionComponent,
        LogsDisplayModalComponent,
        LoaderComponent,
        DashboardComponent,
        StatusFilterPipe,
        ChartComponent,
        PieChartComponent,
        MatSelectSearchComponent,
        ScreencastActionModelComponent,
        DisplayToastComponent,
        TeamListComponent,
        TeamMemberListComponent,
        ConfirmationDialogComponent,
        UsersTableComponent,
        StackedChartComponent,
        LineChartComponent,
        DonutChartComponent,
        CustomTooltipDirective,
        UserProfileComponent,
        UserSettingPanelComponent,
        EmployeeEditComponent,
        ApplicationUsageChartComponent,
        ApplicationUSageProgressbarComponent,
        BulkUpdateSettingsComponent,
        SignupComponent,
        ForgotPasswordComponent,
        NewPasswordComponent,
        ResetSucessfullyComponent,
        WelcomeComponent,
        QuotaBannerComponent,
        DemoReportModalComponent,
        DialogTemplateComponent,
        AddEmailComponent,
        TooltipDirectiveDirective,
        UserPlansComponent,
        PlanExpiredComponent,
        ApplyCouponComponent,
        BillingHeroComponent,
        UserReportComponent,
        ImportUsersComponent,
        UserFilterComponent,
        UserOptionsComponent,
        GoogleSigninComponent,
        AuthBrandPanelComponent,
        ProfileCompletionModalComponent,
        BillingProfileModalComponent,
        InviteFocusDialogComponent,
        WelcomeNewUserComponent,
        ExportTimeSheetComponent,
        MagicLinkAuthComponent,
        PhoneVerificationModalComponent,
        ScreenshotsComponent,
        SampleDataBannerComponent,
        UserListFilterComponent,
        MinuteStepperComponent,
        GetUsersRolePipe,
        StatusCardComponent,
        ShiftDrawerComponent,
        ShiftFormComponent,
        ShiftManagementComponent,
        SSCard,
        AuditLogsComponent,
        UtcToLocalPipe,
        WorkReplayComponent,
        PlanUpgradeDialogComponent,
        LiveMonitoringComponent,
        LiveTileComponent,
        LiveScreencastQuotaMeterComponent,
        SrcObjectDirective,
        WorkReplayComponent,
        PlanUpgradeDialogComponent,
        FeatureLockedComponent,
        EntitlementLockBannerComponent,
        SsRequiresEntitlementDirective,
        ProfessionalPlanAnnouncementDialogComponent,
        OnBoardingComponent,
        WhatsAppDailySummaryModalComponent,
        DowngradeValidationDialogComponent,
        HiddenToGeneralDialogComponent,
        AdminControlToGeneralDialogComponent,
        PersonalizedSettingsDialogComponent,
        TeamReductionDialogComponent,
        ShiftReductionDialogComponent,
        DeleteShiftDialogComponent,
        PasswordResetsDialogComponent,
        DemoConsoleComponent,
        ConductTimelogsComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatPaginatorModule,
        MatTabsModule,
        MatTableModule,
        MatSortModule,
        MatButtonModule,
        MatIconModule,
        MatBadgeModule,
        MatSidenavModule,
        MatRadioModule,
        MatDialogModule,
        MatMenuModule,
        MatCardModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatNativeDateModule,
        TimeagoModule.forRoot(),
        MatAutocompleteModule,
        MatChipsModule,
        AngularFireMessagingModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireDatabaseModule,
        OverlayModule,
        PortalModule,
        A11yModule,
        MatSnackBarModule,
        TooltipModule,
        NgxSkeletonLoaderModule,
        MatTooltipModule,
        MatProgressBarModule,
        ...TourMatMenu,
        MatDividerModule,
        MatProgressSpinnerModule,
        AvatarModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
        }),
        LoadingBarModule,
        LoadingBarRouterModule,
        LoadingBarHttpClientModule,
        MatCheckboxModule,
        ScrollingModule,
        AbsenceCalendarDialogComponent,
        NgxCountriesDropdownModule,
        PolicyFooterComponent,
        PrivacyPolicyComponent,
        RefundPolicyComponent,
        ShippingExchangePolicyComponent,
        TermsConditionComponent,
        AboutUsComponent,
        QuestionAndAnswerComponent,
        RecaptchaV3Module,
        OnboardingChecklistModule,
        SharedModule,
        ReportsWidgetsModule,
        EmployeeSearchComponent,
        ...SHARED_PIPES,
        // Standalone components (moved out of declarations)
        VerificationCodeComponent,
        UserProfileInfoComponent,
        OptionalSetupHelpLinksComponent,
        ExamplePreviewCardComponent,
        ActivationDataStateComponent
    ], providers: [
        DatePipe,
        SharedService,
        {
            provide: MatDialogRef,
            useValue: {}
        },
        { provide: MAT_DIALOG_DATA, useValue: {} },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HeaderInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CacheInterceptor,
            multi: true
        },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCaptchaV3.site_key },
        MessagingServiceService,
        MagicLinkGuard,
        ShiftService,
        provideHttpClient(withInterceptorsFromDi()),
        provideUiTour()
    ]
})
export class AppModule { }
